/* eslint-disable array-callback-return */
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import { getGDCBitacora, postGDCBitacoraFile, postGDCBitacoraText, deleteGDCBitacoraFile } from '@auteco/services/gdcServices'
import Paper from '@material-ui/core/Paper'
import { Typography, TextField, IconButton, OutlinedInput } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React, { useEffect, useRef, useState } from 'react'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import Box from '@material-ui/core/Box'
import fileIcon from 'src/assets/images/fileIcon.png'
import GetAppIcon from '@material-ui/icons/GetApp'
import SearchIcon from '@material-ui/icons/Search'
import CancelOutlined from '@material-ui/icons/CancelOutlined';
import { downloadFile } from '@auteco/utils/downloadFile'
import { toBase64 } from '@auteco/utils/toBase64'
import { useStyles } from './styles'


const Bitacora = ({ partner, clusterId, isEnabled }) => {
  const [bitacor, setBitacora] = useState([])
  const [showedFiles, setShowedFiles] = useState([])
  const [message, setMessage] = useState('')
  const [file, setFile] = useState({ name: '', file: '', type: '' })
  const [alertInfo, setAlertInfo] = useState({ open: false, onClose: () => { }, title: '', content: '', onlyButton: false, btn1Txt: '', btn2Txt: '', btn1Func: () => { }, btn2Func: () => { } })

  const classes = useStyles()
  const inputFileRef = useRef(null)

  const reloadBitacora = async () => {
    const { bitacora } = await getGDCBitacora({ partner, clusterId })
    setBitacora(bitacora)
    setShowedFiles(bitacora)
  }

  const filterFiles = (value) => {
    const newFiles = bitacor.filter(item => item.texto.toLowerCase().includes(value.toLowerCase()))
    setShowedFiles(newFiles)
  }
  const handleSendMessage = async () => {
    const body = {
      cluster_id: clusterId,
      solicitante: partner
    }
    if (message) {
      const bodyTxt = {
        ...body,
        texto: message,
      }
      await postGDCBitacoraText({ params: bodyTxt })
    }
    if (file.file !== '') {
      const bodyFile = {
        ...body,
        archivo: file.file,
        tipo: file.type,
        texto: file.name
      }
      const response = await postGDCBitacoraFile({ params: bodyFile })
      if (response.status === 413) {
        setAlertInfo(
          {
            open: true,
            onClose: () => setAlertInfo({ ...alertInfo, open: false }),
            title: '!Error!',
            content: 'El tamaño de este archivo es muy grande, intenta con otro.',
            onlyButton: true,
            btn1Txt: 'Aceptar',
            btn1Func: () => setAlertInfo({ ...alertInfo, open: false })
          })
      }
    }
    reloadBitacora()
    // Limpiar el estado después de enviar el mensaje
    setMessage('')
    setFile({ name: '', file: '', type: '' })
    inputFileRef.current.value = null
  }

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0]
    const fileBase64 = await toBase64(selectedFile)
    setFile({ name: selectedFile.name, file: fileBase64, type: selectedFile.type })
  }

  const deleteFile = async (id) => {
    const response = await deleteGDCBitacoraFile({ id })
    if (response.success) {
      reloadBitacora()
    }
  }

  useEffect(() => {
    if (clusterId) {
      reloadBitacora()
    }
  }, [clusterId])

  return (
    <>
      <Paper className={classes.list}>
        <OutlinedInput
          placeholder='Buscar mensajes o archivos'
          className={classes.searchInput}
          onChange={(e) => filterFiles(e.target.value)}
          endAdornment={<SearchIcon />}
        />
        <CardBody className={classes.listContainer}>
          {/* implementar logica de archivos con el get */}
          {showedFiles?.map(item => {
            if (item.tipo_peticion === 'texto') {
              return (
                <div className={classes.messageContainer}>
                  <IconButton className={classes.cancelBtn} disabled={!isEnabled} onClick={() => deleteFile(item.id)} >
                    <CancelOutlined />
                  </IconButton>
                  <div
                    className={classes.messageBubble}
                  >
                    <Typography className={classes.nameTxt}>{item.texto}</Typography>
                  </div>
                </div>
              )
            }
            if (item.tipo_peticion === 'image/jpeg') {
              return (
                <div className={classes.messageImgContainer}>
                  <IconButton className={classes.cancelBtn} disabled={!isEnabled} onClick={() => deleteFile(item.id)} >
                    <CancelOutlined />
                  </IconButton>
                  <img src={item.archivo_url} alt='Imagen adjunta' className={classes.img} />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.nameTxt}>{item.texto}</Typography>
                    <IconButton
                      className={classes.btnDownload}
                      disabled={!isEnabled}
                      onClick={() => downloadFile({ urlFile: item.archivo_url, name: item.texto })}
                    >
                      <GetAppIcon />
                    </IconButton>
                  </div>
                </div>
              )
            }
            if (item.tipo_peticion !== 'texto') {
              return (
                <div className={classes.messageFileContainer}>
                  <IconButton className={classes.cancelBtn} disabled={!isEnabled} onClick={() => deleteFile(item.id)} >
                    <CancelOutlined />
                  </IconButton>
                  <img src={fileIcon} alt='Archivo adjunto' className={classes.fileImg} />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.nameTxt}>{item.texto}</Typography>
                    <IconButton
                      className={classes.btnDownload}
                      disabled={clusterId === undefined || !isEnabled}
                      onClick={() => downloadFile({ urlFile: item.archivo_url, name: item.texto })}
                    >
                      <GetAppIcon />
                    </IconButton>
                  </div>
                </div>
              )
            }
          })}
        </CardBody>
      </Paper >
      <Paper elevation={3} className={classes.chatContainer}>
        {/* Agregar más mensajes aquí */}
        <div className={classes.inputContainer}>
          <TextField
            className={classes.textField}
            label="Escribe tu mensaje"
            variant="outlined"
            size="small"
            value={message}
            disabled={!isEnabled}
            onChange={(event) => setMessage(event.target.value)}
          />
          <input
            ref={inputFileRef}
            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx"
            className={classes.fileInput}
            id="file-input-bitacora"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="file-input-bitacora">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {file?.name && <Typography className={classes.fileName}>{file.name}</Typography>}
              <IconButton
                className={classes.fileButton}
                color="primary"
                component="span"
                disabled={clusterId === undefined || !isEnabled}
              >
                <AttachFileIcon />
              </IconButton>
            </Box>
          </label>
          <Button
            variant="contained"
            color="primary"
            disabled={clusterId === undefined || !isEnabled}
            onClick={handleSendMessage}
          >
            Enviar
          </Button>
        </div>
      </Paper>
    </>
  )
}

export { Bitacora }
